<template>
	<div>
		<a class="hover-link" style="float:left;color:white;font-size: 14px;margin-right:20px;" @click="showModalTemp()">Add monthly Expense</a>
		<modal name="expense-form" @before-open="beforeOpen" height="auto" :minHeight="600" width="80%">
			
				<div class="" id="expenseModal" role="dialog">
					<div class="">
						<!-- Modal content-->
						<expense-form :building-id="buildingId" :component="component"></expense-form>			  			 					
					</div>
                </div>
		</modal>
	</div>
</template>
<script>
export default {
  props: ["buildingId", "component"],
  data: function () {
    return {};
  },
  mounted() {
    //alert(this.buildingId);
  },

  methods: {
    beforeOpen(event) {},
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {},
    showModalTemp: function () {
      this.$modal.show("expense-form");
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      this.$modal.show("expense-form");
    },
    hide() {
      this.$modal.hide("expense-form");
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    total: function () {
      return this.expenseFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
  },
}; // Our Javascript logic
</script>